export default __webpack_public_path__ + "static/media/warn.961b743f.svg";